import React from 'react'

import { codeStatus } from 'features/customers/constants/codeStatus'

import { StatusChip } from 'components/_base'

type CustomerCodeStatusProps = {
  code_status?: string
}

const CustomerCodeStatus = ({ code_status }: CustomerCodeStatusProps) => <StatusChip {...codeStatus(code_status)} />

export default CustomerCodeStatus
